import {getTopLevelPcbLayoutNodeUids} from "@buildwithflux/core";
import type {AnyPcbNode, IDocumentData} from "@buildwithflux/models";
import {createSelector} from "reselect";

import type {DocumentSelector, DocumentStoreState, ParameterizedSelector} from "../types";
import {emptyArray} from "../utils";

/**
 * Base selectors for PCB layout nodes - direct state reads
 */

/** Gets a PCB layout node by UID */
export const byUid: ParameterizedSelector<string, AnyPcbNode | undefined> = (uid: string) => {
    return (state: DocumentStoreState) => state.pcbLayoutNodes?.[uid];
};

/** Gets the top-level PCB layout node UIDs - memoized */
export const topLevelUids: DocumentSelector<string[]> = createSelector(
    [(state: DocumentStoreState) => state.pcbLayoutNodes],
    (pcbLayoutNodes): string[] => {
        if (!pcbLayoutNodes) return emptyArray;
        return getTopLevelPcbLayoutNodeUids(pcbLayoutNodes);
    },
);

/** Gets the UID of the Components container node, or null if not found - memoized */
export const componentsContainerUid: DocumentSelector<string | null> = createSelector(
    [(state: DocumentStoreState) => state.pcbLayoutNodes],
    (nodes): string | null => {
        if (!nodes) return null;

        for (const node of Object.values(nodes)) {
            if (node.name === "Components" && node.type === "container") {
                return node.uid;
            }
        }
        return null;
    },
);
